<template>
  <el-dialog
      :title="title"
      top="5vh"
      :visible.sync="dialogVisible" :width="width">
    <div class="lj-detail-body">
        <slot name="body"></slot>

    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "detailDialogPage",
  data() {
    return {}
  },
  props: {
    title: String,//标题
    width: [String, Number]
  }
}
</script>

<style>

</style>